import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslations } from 'use-intl';

import { ReferralFraudClient } from '@/components/admin/referral-fraud-client';
import { PageHeader } from '@/components/dashboard/page-header';

export const Route = createFileRoute('/_admin/admin/referrals')({
  component: ReferralFraudPage,
});

function ReferralFraudPage(): React.ReactElement {
  const t = useTranslations('admin.referralFraud');
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
      <PageHeader title={t('pageTitle')} subtitle={t('pageSubtitle')} />
      <ReferralFraudClient />
    </div>
  );
}
